import React, { useState } from 'react';
import { Formik } from 'formik';
import {
  Button,
  Grid,
  TextField,
  withStyles,
  CircularProgress,
  Divider,
  Typography,
  Tooltip,
  makeStyles,
  InputAdornment
} from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import logo from '../img/logo.png';
import logoCyD from '../img/logo-cyd.png';
import logoPSI from '../img/logo-psi.png';
import logoC3 from '../img/logo-c3.png';
import logoCDZ from '../img/logo-cdz.png';
import logoTEC from '../img/logo-cyd-tec.png';
import * as Yup from 'yup';
import GoogleButton from './GoogleButton';
import MicrosoftButton from './MicrosoftButton';

const useStyles = makeStyles(theme => ({
  customTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px'
    },
    '& .MuiInputBase-root': {
      height: '42px'
    },
    '& .MuiInputLabel-root': {
      top: '-5px'
    },
    '& .MuiInputLabel-shrink': {
      top: '0'
    }
  },
  columna: {
    width: '75%',
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  logoCyD: {
    marginTop: 50,
    [theme.breakpoints.down('md')]: {
      marginTop: 120
    }
  },
  logosEmpresas: {
    width: '75%',
    height: 110,
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      width: '90%',
      height: 75
    }
  }
}));

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

function Login(props) {
  const { handleOnSubmit, handleGoogleLogin, loading, handleMicrosoftLogin } = props;
  const classes = useStyles();
  const [formularioExternoVisible, setFormularioExternoVisible] = useState(false);

  const values = {
    email: '',
    password: ''
  };

  const validation = Yup.object({
    email: Yup.string().email().required('El email es requerido.'),
    password: Yup.string().required('El contaseña es requerido.')
  });

  return (
    <div>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ height: '100vh', minHeight: 'fit-content' }}>
          <Grid item className={classes.logoCyD}>
            <img src={logo} alt="img" width={100} />
          </Grid>
          <Grid item style={{ width: '75%', marginTop: 35 }}>
            <Grid container justifyContent="center" alignItems="center">
              <Typography
                style={{
                  fontFamily: "'Roboto', Arial, sans-serif",
                  fontSize: '18px',
                  fontWeight: '500',
                  textAlign: 'center',
                  marginRight: 10
                }}>
                Iniciar sesión
              </Typography>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    Ingreso <b>Google:</b> CyD Ingeniería, PSI Consultores, CyD Tecnología y CDZ Minería.
                    <br />
                    Ingreso <b>Microsoft:</b> Consorcio C3, Ingeniería CDZ.
                  </React.Fragment>
                }>
                <InfoOutlinedIcon color="primary" />
              </HtmlTooltip>
            </Grid>
          </Grid>
          <Grid item xs style={{ width: '100%' }}>
            {!formularioExternoVisible ? (
              <Grid container direction="column" justifyContent="center" alignItems="center" style={{ marginTop: 10 }}>
                <Grid item className={classes.columna} style={{ marginTop: 10 }}>
                  <GoogleButton text="Continuar con Google" onClick={handleGoogleLogin} style={{ width: '100%' }} />
                </Grid>
                <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                  <MicrosoftButton
                    text="Continuar con Microsoft"
                    onClick={handleMicrosoftLogin}
                    style={{ width: '100%' }}
                  />
                </Grid>
                <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                  <Divider />
                </Grid>
                <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    style={{
                      borderRadius: 12,
                      width: '100%',
                      fontFamily: "'Roboto', Arial, sans-serif",
                      fontSize: '14px',
                      fontWeight: '500',
                      textTransform: 'none'
                    }}
                    onClick={() => setFormularioExternoVisible(!formularioExternoVisible)}>
                    Acceso externo
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Formik
                onSubmit={handleOnSubmit}
                initialValues={values}
                validationSchema={validation}
                //onChange={handleChange}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  isValid
                  /* and other goodies */
                }) => (
                  <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="large"
                        style={{
                          borderRadius: 12,
                          width: '100%',
                          fontFamily: "'Roboto', Arial, sans-serif",
                          fontSize: '14px',
                          fontWeight: '500',
                          textTransform: 'none'
                        }}
                        onClick={() => setFormularioExternoVisible(!formularioExternoVisible)}>
                        Iniciar sesión con otro servicio
                      </Button>
                    </Grid>
                    <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                      <Divider />
                    </Grid>
                    <Grid item className={classes.columna} style={{ marginTop: 20 }}>
                      <Grid container justifyContent="center" alignItems="center">
                        <Typography
                          align="center"
                          variant="body2"
                          gutterBottom
                          style={{
                            opacity: 0.7,
                            paddingBottom: 10,
                            paddingLeft: 20,
                            paddingRight: 20
                          }}>
                          Ingresa tu correo electrónico y la contraseña proporcionada por el equipo CyDocs
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item className={classes.columna} style={{ marginTop: 10 }}>
                      <form onSubmit={handleSubmit} autoComplete="off">
                        <Grid container direction="column" justifyContent="center" alignItems="center">
                          <Grid item style={{ width: '100%' }}>
                            <TextField
                              className={classes.customTextField}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <MailOutlineIcon style={{ color: 'gray' }} />
                                  </InputAdornment>
                                )
                              }}
                              name="email"
                              label="Correo"
                              value={values.email}
                              variant="outlined"
                              fullWidth
                              required
                              error={touched.email && errors.email && Boolean(errors.email)}
                              helperText={touched.email && errors.email ? errors.email : ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item style={{ width: '100%', marginTop: 20 }}>
                            <TextField
                              className={classes.customTextField}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <VpnKeyOutlinedIcon style={{ color: 'gray' }} />
                                  </InputAdornment>
                                )
                              }}
                              size="small"
                              name="password"
                              label="Contraseña"
                              value={values.password}
                              variant="outlined"
                              type="password"
                              fullWidth
                              required
                              error={touched.password && errors.password && Boolean(errors.password)}
                              helperText={touched.password && errors.password ? errors.password : ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item style={{ width: '100%', marginTop: 20 }}>
                            <Button
                              type="submit"
                              fullWidth
                              disabled={!isValid}
                              variant="contained"
                              style={{ borderRadius: '12px', textTransform: 'none' }}
                              color="primary"
                              size="large"
                              disableElevation>
                              Iniciar sesión
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            )}
          </Grid>
          <Grid item className={classes.logosEmpresas}>
            <Divider />
            <Grid container style={{ marginTop: 15 }} justifyContent="space-between" alignItems="center">
              <img src={logoCyD} alt="img" width={50} />
              <img src={logoPSI} alt="img" width={90} />
              <img src={logoC3} alt="img" width={40} />
              <img src={logoCDZ} alt="img" width={75} />
              <img src={logoTEC} alt="img" width={50} />
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

export default Login;
